import { Order } from 'entities/order'
import { ViewModel } from 'view_models/view_model'

export class OrderViewModel extends ViewModel<Order> {
    public date = () => {
        return this.toDateText(this.object.date)
    }

    public inspectedAt = () => {
        return this.toDateTimeText(this.object.inspectedAt)
    }
}
